import { OverlayTrigger as Bs5OlTrigger } from 'react-bootstrap5';

export default Bs5OlTrigger;
